import { render } from "./Disclaimer.vue?vue&type=template&id=91603cb6"
import script from "./Disclaimer.vue?vue&type=script&lang=ts"
export * from "./Disclaimer.vue?vue&type=script&lang=ts"
script.render = render

export default script